import AppService from "./app-service"

const path = "exam-requests"

export default class ExamRequestService extends AppService {

  constructor() {
    super({ path })
  }

  static get STATUS() {
    return {
      waiting_certs: { icon: "clock orange icon", description: "Aguardando laudos" },
      certs_finished: { icon: "check circle green icon", description: "Laudos finalizados" },
    }
  }

  filter(data) {
    return this.http.post(`${path}/filter`, data)
  }

  searchPendingRequests(search) {
    return this.http.post(`${path}/pending-requests`, { search })
  }

  canUpdate(request) {

    let canUpdate = true

    for (let type of request.examTypes) {
      if (type.certId) {
        canUpdate = false
        break
      }  
    }

    return canUpdate
  }
}